import apiHeader from '@/helpers/apiHeader';

const activityLogService = {
  list(params) {
    return apiHeader.get('report/activity-log', { params });
  },
  get(id) {
    return apiHeader.get('report/activity-log/' + id);
  },
  export() {
    return apiHeader.get(`report/activity-log/export`, {
      responseType: 'blob',
    });
  },
};

export default activityLogService;
